const template1 = {
  tagName: "mj-global-style",
  attributes: {
    "h1:color": "#000",
    "h1:font-family": "Helvetica, sans-serif",
    "h2:color": "#000",
    "h2:font-family": "Ubuntu, Helvetica, Arial, sans-serif",
    "h3:color": "#000",
    "h3:font-family": "Ubuntu, Helvetica, Arial, sans-serif",
    ":color": "#000",
    ":font-family": "Ubuntu, Helvetica, Arial, sans-serif",
    ":line-height": "1.5",
    "a:color": "#24bfbc",
    "button:background-color": "#e85034",
    containerWidth: 600,
    fonts: "Helvetica,sans-serif,Ubuntu,Arial",
    "mj-text": {
      "line-height": 1.5,
      "font-size": 15,
      "font-family": "Ubuntu, sans-serif",
    },
    "mj-button": { "font-size": "13px" },
  },
  children: [
    {
      tagName: "mj-body",
      attributes: { "background-color": "#FFFFFF", containerWidth: 600 },
      children: [
        {
          tagName: "mj-section",
          attributes: {
            "full-width": "600px",
            padding: "10px 10px",
            "mj-class": "section",
            "in-group": true,
          },
          children: [
            {
              tagName: "mj-column",
              attributes: {
                width: "70%",
                "vertical-align": "middle",
                "background-color": "#E85034",
                "border-radius": "10px",
                "css-class": "rounded",
                padding: "0px 5px 0px 5px",
              },
              children: [
                {
                  uid: "ibae6wOpP",
                  tagName: "mj-text",
                  content:
                    "<p>This is your new text block with first paragraph.</p>",
                  attributes: {
                    align: "left",
                    padding: "15px 15px 15px 15px",
                    "line-height": 1.5,
                    containerWidth: 420,
                  },
                  customKey: null,
                },
              ],
              uid: "HJQ8ytZzW",
            },
            {
              tagName: "mj-column",
              attributes: { width: "30%", "vertical-align": "middle" },
              children: [
                {
                  uid: "_t-luQINW",
                  tagName: "mj-social",
                  attributes: {
                    padding: "5px 5px 5px 5px",
                    "text-mode": "false",
                    "icon-size": "30px",
                    align: "right",
                    containerWidth: 180,
                    "icon-padding": "1px",
                  },
                  children: [
                    {
                      tagName: "mj-social-element",
                      attributes: {
                        src: "https://s3-eu-west-1.amazonaws.com/ecomail-assets/editor/social-icos/ikony-black/roundedblack/facebook.png",
                        name: "facebook-noshare",
                        alt: "Facebook",
                        href: "https://www.facebook.com/PROFILE",
                        "background-color": "transparent",
                        show: true,
                      },
                    },
                    {
                      tagName: "mj-social-element",
                      attributes: {
                        src: "https://s3-eu-west-1.amazonaws.com/ecomail-assets/editor/social-icos/ikony-black/roundedblack/x.png",
                        name: "x-noshare",
                        alt: "X",
                        href: "https://www.x.com/PROFILE",
                        "background-color": "transparent",
                        show: true,
                      },
                    },
                    {
                      tagName: "mj-social-element",
                      attributes: {
                        src: "https://s3-eu-west-1.amazonaws.com/ecomail-assets/editor/social-icos/ikony-black/roundedblack/linkedin.png",
                        name: "linkedin-noshare",
                        alt: "LinkedIn",
                        href: "https://www.linkedin.com/PROFILE",
                        "background-color": "transparent",
                        show: true,
                      },
                    },
                    {
                      tagName: "mj-social-element",
                      attributes: {
                        src: "https://s3-eu-west-1.amazonaws.com/ecomail-assets/editor/social-icos/ikony-black/roundedblack/instagram.png",
                        alt: "Instagram",
                        name: "instagram",
                        href: "https://www.instagram.com/PROFILE",
                        "background-color": "transparent",
                        show: true,
                      },
                    },
                  ],
                  style: "ikony-black/roundedblack",
                },
              ],
              uid: "uYQDAfdIz9",
            },
          ],
          layout: 1,
          backgroundColor: null,
          backgroundImage: null,
          paddingTop: 0,
          paddingBottom: 0,
          paddingLeft: 0,
          paddingRight: 0,
          uid: "Byggju-zb",
        },
        {
          uid: "UhrRhJgog",
          tagName: "mj-section",
          attributes: {
            "full-width": false,
            padding: "10px 10px",
            "mj-class": "section",
          },
          type: null,
          children: [
            {
              tagName: "mj-column",
              attributes: { width: "100%", "vertical-align": "top" },
              children: [
                {
                  uid: "CWyAe1Vit",
                  tagName: "mj-image",
                  attributes: {
                    src: "https://storage.googleapis.com/topol-io-plugin-97de3577-4897-4379-9699-a51756301fab/plugin-assets/17326/user/Enca_edited_only_jpg.jpg",
                    padding: "0px 0px 0px 0px",
                    "fluid-on-mobile": "false",
                    alt: "",
                    href: "",
                    containerWidth: 600,
                    "border-radius": "0px 0px 0px 0px",
                  },
                  customKey: null,
                },
                {
                  uid: "gKHNSFJuf",
                  tagName: "mj-button",
                  attributes: {
                    align: "center",
                    "background-color": "#000000",
                    color: "#ffffff",
                    "border-radius": "10px",
                    "font-size": "13px",
                    padding: "10px 0px 10px 0px",
                    "inner-padding": "10px 25px 10px 25px",
                    href: "https://google.com",
                    "font-family":
                      "Ubuntu, Helvetica, Arial, sans-serif, Helvetica, Arial, sans-serif",
                    containerWidth: 600,
                    "font-weight": "normal",
                    "font-style": "normal",
                    "text-transform": "none",
                    "text-decoration": "none",
                  },
                  content: "Click me!",
                  customKey: null,
                },
              ],
              uid: "--FRAnCV-R",
            },
          ],
          layout: 1,
          backgroundColor: "",
          backgroundImage: "",
          paddingTop: 0,
          paddingBottom: 0,
          paddingLeft: 0,
          paddingRight: 0,
        },
        {
          uid: "wzaN4vqUQ",
          tagName: "mj-section",
          attributes: {
            "full-width": "600px",
            padding: "10px 10px",
            "mj-class": "section",
          },
          type: null,
          children: [
            {
              tagName: "mj-column",
              attributes: { width: "100%", "vertical-align": "top" },
              children: [
                {
                  uid: "hzHpOgWUv",
                  tagName: "mj-text",
                  content:
                    "<p>This is your new text block with first paragraph.</p>",
                  attributes: {
                    align: "left",
                    padding: "15px 15px 15px 15px",
                    "line-height": 1.5,
                    containerWidth: 600,
                  },
                  customKey: null,
                },
                {
                  uid: "OKezUKnZ4",
                  tagName: "mj-button",
                  attributes: {
                    align: "center",
                    "background-color": "#e85034",
                    color: "#ffffff",
                    "border-radius": "8px",
                    "font-size": "13px",
                    padding: "10px 10px 10px 10px",
                    "inner-padding": "10px 20px 10px 20px",
                    href: "https://google.com",
                    "font-family":
                      "Ubuntu, Helvetica, Arial, sans-serif, Helvetica, Arial, sans-serif",
                    containerWidth: 600,
                    "font-weight": "normal",
                    "font-style": "normal",
                    "text-transform": "none",
                    "text-decoration": "none",
                    width: "100%",
                  },
                  content: "Click me!",
                  customKey: null,
                },
              ],
              uid: "--FRAnCV-R",
            },
          ],
          layout: 1,
          backgroundColor: "",
          backgroundImage: "",
          paddingTop: 0,
          paddingBottom: 0,
          paddingLeft: 0,
          paddingRight: 0,
        },
        {
          uid: "lzm8qI-TS",
          tagName: "mj-section",
          attributes: {
            "full-width": false,
            padding: "10px 10px",
            "mj-class": "section",
            "css-class": "hide_section_on_mobile",
            "background-url":
              "https://storage.googleapis.com/topol-io-plugin-97de3577-4897-4379-9699-a51756301fab/plugin-assets/17326/user/testuju_separe.jpg",
            "background-repeat": "no-repeat",
            "background-size": "Cover",
          },
          type: null,
          children: [
            {
              tagName: "mj-column",
              attributes: { width: "100%", "vertical-align": "top" },
              children: [
                {
                  uid: "74pW-aT8_",
                  tagName: "mj-divider",
                  attributes: {
                    "border-color": "#000000",
                    "border-style": "solid",
                    "border-width": "1px",
                    "padding-top": "10px",
                    "padding-right": "10px",
                    containerWidth: 600,
                    padding: "10px 10px",
                  },
                },
                {
                  uid: "eAnpeTpgm",
                  tagName: "mj-spacer",
                  attributes: {
                    height: "300px",
                    containerWidth: 600,
                    "css-class": "",
                  },
                },
                {
                  uid: "Xat5PBjpP",
                  tagName: "mj-divider",
                  attributes: {
                    "border-color": "#000000",
                    "border-style": "solid",
                    "border-width": "1px",
                    "padding-top": "10px",
                    "padding-right": "10px",
                    containerWidth: 600,
                    padding: "10px 10px",
                  },
                },
              ],
              uid: "--FRAnCV-R",
            },
          ],
          layout: 1,
          backgroundColor: "",
          backgroundImage: "",
          paddingTop: 0,
          paddingBottom: 0,
          paddingLeft: 0,
          paddingRight: 0,
        },
        {
          uid: "pA7VRRKZK",
          tagName: "mj-section",
          attributes: {
            "full-width": "600px",
            padding: "10px 10px",
            "mj-class": "section",
          },
          type: null,
          children: [
            {
              tagName: "mj-column",
              attributes: { width: "25%", "vertical-align": "bottom" },
              children: [
                {
                  uid: "Yxl4rIeNO",
                  tagName: "mj-text",
                  content:
                    "<p>This is your new text block with first paragraph. This is your new text block with first paragraph.</p>",
                  attributes: {
                    align: "left",
                    padding: "15px 15px 15px 15px",
                    "line-height": 1.5,
                    containerWidth: 150,
                  },
                  customKey: null,
                },
              ],
              uid: "AoQ5FiJtVZ",
            },
            {
              tagName: "mj-column",
              attributes: { width: "25%", "vertical-align": "bottom" },
              children: [
                {
                  uid: "fHyeyCDIz",
                  tagName: "mj-text",
                  content:
                    "<p>This is your new text block with first paragraph.</p>",
                  attributes: {
                    align: "left",
                    padding: "15px 15px 15px 15px",
                    "line-height": 1.5,
                    containerWidth: 150,
                  },
                  customKey: null,
                },
              ],
              uid: "TEbBAxIZVv",
            },
            {
              tagName: "mj-column",
              attributes: { width: "25%", "vertical-align": "bottom" },
              children: [
                {
                  uid: "fzIe25oAK",
                  tagName: "mj-text",
                  content:
                    "<p>This is your new text block with first paragraph.</p>",
                  attributes: {
                    align: "left",
                    padding: "15px 15px 15px 15px",
                    "line-height": 1.5,
                    containerWidth: 150,
                  },
                  customKey: null,
                },
              ],
              uid: "9WjQgToxbI",
            },
            {
              tagName: "mj-column",
              attributes: { width: "25%", "vertical-align": "bottom" },
              children: [
                {
                  uid: "9jiHQuaaW",
                  tagName: "mj-text",
                  content:
                    "<p>This is your new text block with first paragraph.</p>",
                  attributes: {
                    align: "left",
                    padding: "15px 15px 15px 15px",
                    "line-height": 1.5,
                    containerWidth: 150,
                  },
                  customKey: null,
                },
              ],
              uid: "uZIFdR-9oI",
            },
          ],
          layout: 1,
          backgroundColor: "",
          backgroundImage: "",
          paddingTop: 0,
          paddingBottom: 0,
          paddingLeft: 0,
          paddingRight: 0,
        },
        {
          tagName: "mj-section",
          attributes: {
            "full-width": false,
            padding: "10px 0px 5px 0px",
            "mj-class": "section",
          },
          children: [
            {
              tagName: "mj-column",
              attributes: { width: "100%", "vertical-align": "top" },
              children: [
                {
                  tagName: "mj-feed-block",
                  uid: "ysyVSlZTu",
                  attributes: {
                    containerWidth: 600,
                    dynamic: true,
                    "columns-layout": "text-image",
                    image:
                      "https://storage.googleapis.com/topol-io-plugin-97de3577-4897-4379-9699-a51756301fab/plugin-assets/17326/user/pexels-622acd70-c0da-48b4-bdf6-53eee9685cfa_edited_703b5ff7-e794-4c44-9adb-a5f24748686a.jpg",
                    "image-width": 300,
                    "image-alt": "",
                    "image-title": "",
                    "image-fluid-on-mobile": "false",
                    "image-align": "center",
                    href: "http://www.example.com/media/dvd/?sku=384616&src=gshopping&lang=en",
                    title:
                      '<div style="font-family: inherit;">Latte Art for Beginners</div>',
                    "raw-title": "Latte Art for Beginners",
                    "title-font-size": "17px",
                    "title-color": "#000000",
                    "title-font-family": "Ubuntu, Helvetica, Arial, sans-serif",
                    "title-font-weight": "bold",
                    "title-font-style": "normal",
                    "title-text-transform": "none",
                    "title-text-decoration": "none",
                    "title-padding": "10px 10px 0px 10px",
                    "title-align": "center",
                    description:
                      '<div style="font-family: inherit;">Due to the great success we are reopening the milk foam magic course.<br>Max. capacity 10 participants.</div>',
                    "raw-description":
                      "Due to the great success we are reopening the milk foam magic course.Max. capacity 10 participants.",
                    "description-font-size": "14px",
                    "description-color": "#999999",
                    "description-font-family":
                      "Ubuntu, Helvetica, Arial, sans-serif",
                    "description-font-weight": "normal",
                    "description-font-style": "normal",
                    "description-text-transform": "none",
                    "description-text-decoration": "none",
                    "description-padding": "5px 10px 5px 10px",
                    "description-align": "center",
                    "price-before":
                      '<div style="font-family: inherit;">49 €</div>',
                    "raw-price-before": "49 €",
                    "price-before-font-size": "13px",
                    "price-before-color": "#000000",
                    "price-before-font-family":
                      "Ubuntu, Helvetica, Arial, sans-serif",
                    "price-before-font-weight": "normal",
                    "price-before-font-style": "normal",
                    "price-before-text-transform": "none",
                    "price-before-text-decoration": "line-through",
                    "price-before-padding": "5px 10px 5px 10px",
                    "price-before-align": "center",
                    price: '<div style="font-family: inherit;">40 €</div>',
                    "raw-price": "40 €",
                    "price-font-size": "18px",
                    "price-color": "#000000",
                    "price-font-family": "Ubuntu, Helvetica, Arial, sans-serif",
                    "price-font-weight": "normal",
                    "price-font-style": "normal",
                    "price-text-transform": "none",
                    "price-text-decoration": "none",
                    "price-padding": "5px 10px 5px 10px",
                    "price-align": "center",
                    "button-align": "center",
                    "button-background-color": "#000000",
                    "button-color": "#FFFFFF",
                    "button-font-size": "13px",
                    "button-font-family":
                      "Ubuntu, Helvetica, Arial, sans-serif",
                    "button-font-weight": "normal",
                    "button-font-style": "normal",
                    "button-text-transform": "none",
                    "button-text-decoration": "none",
                    "button-border-radius": "3px",
                    "button-padding": "5px 10px 10px 10px",
                    "button-inner-padding": "10px 20px 10px 20px",
                    button: "Buy Now",
                    layout:
                      "image:show,title:show,description:show,priceBefore:show,price:show,button:show",
                    "image-padding": "10px 10px 10px 10px",
                    "button-width": "100%",
                    product_id: 68,
                    product_feed_id: 37,
                  },
                  blockName: "product",
                },
              ],
              uid: "jrlNPldzIp",
            },
          ],
          layout: 1,
          backgroundColor: "",
          backgroundImage: "",
          paddingTop: 0,
          paddingBottom: 0,
          paddingLeft: 0,
          paddingRight: 0,
          uid: "EjCDC8OJZC",
        },
      ],
    },
  ],
  style: {
    h1: {
      "font-family": "Ubuntu, sans-serif",
      "font-size": "22px",
      "font-weight": "bold",
    },
    a: { color: "#0000EE" },
    h2: {
      "font-family": "Ubuntu, Helvetica, Arial",
      "font-size": "17px",
      "font-weight": "bold",
    },
    h3: {
      "font-family": "Ubuntu, Helvetica, Arial",
      "font-size": "13px",
      "font-weight": "bold",
    },
    p: { "font-family": "Ubuntu, sans-serif", "font-size": "11px" },
    ul: { "font-size": "11px", "font-family": "Ubuntu, sans-serif" },
    li: { "font-size": "11px", "font-family": "Ubuntu, sans-serif" },
    ol: { "font-size": "11px", "font-family": "Ubuntu, sans-serif" },
    ".rounded>table": { "border-collapse": "separate" },
  },
  fonts: ["Ubuntu, sans-serif", "Ubuntu, Helvetica, Arial"],
  feedBlocksApplyToAll: {},
};

const template2 = {
  tagName: "mj-global-style",
  attributes: {
    "h1:color": "#000",
    "h1:font-family": "Helvetica, sans-serif",
    "h2:color": "#000",
    "h2:font-family": "Ubuntu, Helvetica, Arial, sans-serif",
    "h3:color": "#000",
    "h3:font-family": "Ubuntu, Helvetica, Arial, sans-serif",
    ":color": "#000",
    ":font-family": "Ubuntu, Helvetica, Arial, sans-serif",
    ":line-height": "1.5",
    "a:color": "#24bfbc",
    "button:background-color": "#e85034",
    containerWidth: 600,
    fonts: "Helvetica,sans-serif,Ubuntu,Arial",
    "mj-text": {
      "line-height": 1.5,
      "font-size": 15,
      "font-family": "Ubuntu, sans-serif",
    },
    "mj-button": { "font-size": "13px" },
  },
  children: [
    {
      tagName: "mj-body",
      attributes: { "background-color": "#FFFFFF", containerWidth: 600 },
      children: [
        {
          uid: "UhrRhJgog",
          tagName: "mj-section",
          attributes: {
            "full-width": false,
            padding: "10px 10px",
            "mj-class": "section",
          },
          type: null,
          children: [
            {
              tagName: "mj-column",
              attributes: { width: "100%", "vertical-align": "top" },
              children: [
                {
                  uid: "CWyAe1Vit",
                  tagName: "mj-image",
                  attributes: {
                    src: "https://storage.googleapis.com/topol-io-plugin-97de3577-4897-4379-9699-a51756301fab/plugin-assets/17326/user/Enca_edited_only_jpg.jpg",
                    padding: "0px 0px 0px 0px",
                    "fluid-on-mobile": "false",
                    alt: "",
                    href: "",
                    containerWidth: 600,
                    "border-radius": "0px 0px 0px 0px",
                  },
                  customKey: null,
                },
                {
                  uid: "gKHNSFJuf",
                  tagName: "mj-button",
                  attributes: {
                    align: "center",
                    "background-color": "#000000",
                    color: "#ffffff",
                    "border-radius": "10px",
                    "font-size": "13px",
                    padding: "10px 0px 10px 0px",
                    "inner-padding": "10px 25px 10px 25px",
                    href: "https://google.com",
                    "font-family":
                      "Ubuntu, Helvetica, Arial, sans-serif, Helvetica, Arial, sans-serif",
                    containerWidth: 600,
                    "font-weight": "normal",
                    "font-style": "normal",
                    "text-transform": "none",
                    "text-decoration": "none",
                  },
                  content: "Click me!",
                  customKey: null,
                },
              ],
              uid: "--FRAnCV-R",
            },
          ],
          layout: 1,
          backgroundColor: "",
          backgroundImage: "",
          paddingTop: 0,
          paddingBottom: 0,
          paddingLeft: 0,
          paddingRight: 0,
        },
        {
          uid: "wzaN4vqUQ",
          tagName: "mj-section",
          attributes: {
            "full-width": "600px",
            padding: "10px 10px",
            "mj-class": "section",
          },
          type: null,
          children: [
            {
              tagName: "mj-column",
              attributes: { width: "100%", "vertical-align": "top" },
              children: [
                {
                  uid: "hzHpOgWUv",
                  tagName: "mj-text",
                  content:
                    "<p>This is your new text block with first paragraph.</p>",
                  attributes: {
                    align: "left",
                    padding: "15px 15px 15px 15px",
                    "line-height": 1.5,
                    containerWidth: 600,
                  },
                  customKey: null,
                },
                {
                  uid: "OKezUKnZ4",
                  tagName: "mj-button",
                  attributes: {
                    align: "center",
                    "background-color": "#e85034",
                    color: "#ffffff",
                    "border-radius": "8px",
                    "font-size": "13px",
                    padding: "10px 10px 10px 10px",
                    "inner-padding": "10px 20px 10px 20px",
                    href: "https://google.com",
                    "font-family":
                      "Ubuntu, Helvetica, Arial, sans-serif, Helvetica, Arial, sans-serif",
                    containerWidth: 600,
                    "font-weight": "normal",
                    "font-style": "normal",
                    "text-transform": "none",
                    "text-decoration": "none",
                    width: "100%",
                  },
                  content: "Click me!",
                  customKey: null,
                },
              ],
              uid: "--FRAnCV-R",
            },
          ],
          layout: 1,
          backgroundColor: "",
          backgroundImage: "",
          paddingTop: 0,
          paddingBottom: 0,
          paddingLeft: 0,
          paddingRight: 0,
        },
        {
          uid: "lzm8qI-TS",
          tagName: "mj-section",
          attributes: {
            "full-width": false,
            padding: "10px 10px",
            "mj-class": "section",
            "css-class": "hide_section_on_mobile",
            "background-url":
              "https://storage.googleapis.com/topol-io-plugin-97de3577-4897-4379-9699-a51756301fab/plugin-assets/17326/user/testuju_separe.jpg",
            "background-repeat": "no-repeat",
            "background-size": "Cover",
          },
          type: null,
          children: [
            {
              tagName: "mj-column",
              attributes: { width: "100%", "vertical-align": "top" },
              children: [
                {
                  uid: "74pW-aT8_",
                  tagName: "mj-divider",
                  attributes: {
                    "border-color": "#000000",
                    "border-style": "solid",
                    "border-width": "1px",
                    "padding-top": "10px",
                    "padding-right": "10px",
                    containerWidth: 600,
                    padding: "10px 10px",
                  },
                },
                {
                  uid: "eAnpeTpgm",
                  tagName: "mj-spacer",
                  attributes: {
                    height: "300px",
                    containerWidth: 600,
                    "css-class": "",
                  },
                },
                {
                  uid: "Xat5PBjpP",
                  tagName: "mj-divider",
                  attributes: {
                    "border-color": "#000000",
                    "border-style": "solid",
                    "border-width": "1px",
                    "padding-top": "10px",
                    "padding-right": "10px",
                    containerWidth: 600,
                    padding: "10px 10px",
                  },
                },
              ],
              uid: "--FRAnCV-R",
            },
          ],
          layout: 1,
          backgroundColor: "",
          backgroundImage: "",
          paddingTop: 0,
          paddingBottom: 0,
          paddingLeft: 0,
          paddingRight: 0,
        },
        {
          uid: "pA7VRRKZK",
          tagName: "mj-section",
          attributes: {
            "full-width": "600px",
            padding: "10px 10px",
            "mj-class": "section",
          },
          type: null,
          children: [
            {
              tagName: "mj-column",
              attributes: { width: "25%", "vertical-align": "bottom" },
              children: [
                {
                  uid: "Yxl4rIeNO",
                  tagName: "mj-text",
                  content:
                    "<p>This is your new text block with first paragraph. This is your new text block with first paragraph.</p>",
                  attributes: {
                    align: "left",
                    padding: "15px 15px 15px 15px",
                    "line-height": 1.5,
                    containerWidth: 150,
                  },
                  customKey: null,
                },
              ],
              uid: "AoQ5FiJtVZ",
            },
            {
              tagName: "mj-column",
              attributes: { width: "25%", "vertical-align": "bottom" },
              children: [
                {
                  uid: "fHyeyCDIz",
                  tagName: "mj-text",
                  content:
                    "<p>This is your new text block with first paragraph.</p>",
                  attributes: {
                    align: "left",
                    padding: "15px 15px 15px 15px",
                    "line-height": 1.5,
                    containerWidth: 150,
                  },
                  customKey: null,
                },
              ],
              uid: "TEbBAxIZVv",
            },
            {
              tagName: "mj-column",
              attributes: { width: "25%", "vertical-align": "bottom" },
              children: [
                {
                  uid: "fzIe25oAK",
                  tagName: "mj-text",
                  content:
                    "<p>This is your new text block with first paragraph.</p>",
                  attributes: {
                    align: "left",
                    padding: "15px 15px 15px 15px",
                    "line-height": 1.5,
                    containerWidth: 150,
                  },
                  customKey: null,
                },
              ],
              uid: "9WjQgToxbI",
            },
            {
              tagName: "mj-column",
              attributes: { width: "25%", "vertical-align": "bottom" },
              children: [
                {
                  uid: "9jiHQuaaW",
                  tagName: "mj-text",
                  content:
                    "<p>This is your new text block with first paragraph.</p>",
                  attributes: {
                    align: "left",
                    padding: "15px 15px 15px 15px",
                    "line-height": 1.5,
                    containerWidth: 150,
                  },
                  customKey: null,
                },
              ],
              uid: "uZIFdR-9oI",
            },
          ],
          layout: 1,
          backgroundColor: "",
          backgroundImage: "",
          paddingTop: 0,
          paddingBottom: 0,
          paddingLeft: 0,
          paddingRight: 0,
        },
        {
          tagName: "mj-section",
          attributes: {
            "full-width": false,
            padding: "10px 0px 5px 0px",
            "mj-class": "section",
          },
          children: [
            {
              tagName: "mj-column",
              attributes: { width: "100%", "vertical-align": "top" },
              children: [
                {
                  tagName: "mj-feed-block",
                  uid: "ysyVSlZTu",
                  attributes: {
                    containerWidth: 600,
                    dynamic: true,
                    "columns-layout": "text-image",
                    image:
                      "https://storage.googleapis.com/topol-io-plugin-97de3577-4897-4379-9699-a51756301fab/plugin-assets/17326/user/pexels-622acd70-c0da-48b4-bdf6-53eee9685cfa_edited_703b5ff7-e794-4c44-9adb-a5f24748686a.jpg",
                    "image-width": 300,
                    "image-alt": "",
                    "image-title": "",
                    "image-fluid-on-mobile": "false",
                    "image-align": "center",
                    href: "http://www.example.com/media/dvd/?sku=384616&src=gshopping&lang=en",
                    title:
                      '<div style="font-family: inherit;">Latte Art for Beginners</div>',
                    "raw-title": "Latte Art for Beginners",
                    "title-font-size": "17px",
                    "title-color": "#000000",
                    "title-font-family": "Ubuntu, Helvetica, Arial, sans-serif",
                    "title-font-weight": "bold",
                    "title-font-style": "normal",
                    "title-text-transform": "none",
                    "title-text-decoration": "none",
                    "title-padding": "10px 10px 0px 10px",
                    "title-align": "center",
                    description:
                      '<div style="font-family: inherit;">Due to the great success we are reopening the milk foam magic course.<br>Max. capacity 10 participants.</div>',
                    "raw-description":
                      "Due to the great success we are reopening the milk foam magic course.Max. capacity 10 participants.",
                    "description-font-size": "14px",
                    "description-color": "#999999",
                    "description-font-family":
                      "Ubuntu, Helvetica, Arial, sans-serif",
                    "description-font-weight": "normal",
                    "description-font-style": "normal",
                    "description-text-transform": "none",
                    "description-text-decoration": "none",
                    "description-padding": "5px 10px 5px 10px",
                    "description-align": "center",
                    "price-before":
                      '<div style="font-family: inherit;">49 €</div>',
                    "raw-price-before": "49 €",
                    "price-before-font-size": "13px",
                    "price-before-color": "#000000",
                    "price-before-font-family":
                      "Ubuntu, Helvetica, Arial, sans-serif",
                    "price-before-font-weight": "normal",
                    "price-before-font-style": "normal",
                    "price-before-text-transform": "none",
                    "price-before-text-decoration": "line-through",
                    "price-before-padding": "5px 10px 5px 10px",
                    "price-before-align": "center",
                    price: '<div style="font-family: inherit;">40 €</div>',
                    "raw-price": "40 €",
                    "price-font-size": "18px",
                    "price-color": "#000000",
                    "price-font-family": "Ubuntu, Helvetica, Arial, sans-serif",
                    "price-font-weight": "normal",
                    "price-font-style": "normal",
                    "price-text-transform": "none",
                    "price-text-decoration": "none",
                    "price-padding": "5px 10px 5px 10px",
                    "price-align": "center",
                    "button-align": "center",
                    "button-background-color": "#000000",
                    "button-color": "#FFFFFF",
                    "button-font-size": "13px",
                    "button-font-family":
                      "Ubuntu, Helvetica, Arial, sans-serif",
                    "button-font-weight": "normal",
                    "button-font-style": "normal",
                    "button-text-transform": "none",
                    "button-text-decoration": "none",
                    "button-border-radius": "3px",
                    "button-padding": "5px 10px 10px 10px",
                    "button-inner-padding": "10px 20px 10px 20px",
                    button: "Buy Now",
                    layout:
                      "image:show,title:show,description:show,priceBefore:show,price:show,button:show",
                    "image-padding": "10px 10px 10px 10px",
                    "button-width": "100%",
                    product_id: 68,
                    product_feed_id: 37,
                  },
                  blockName: "product",
                },
              ],
              uid: "jrlNPldzIp",
            },
          ],
          layout: 1,
          backgroundColor: "",
          backgroundImage: "",
          paddingTop: 0,
          paddingBottom: 0,
          paddingLeft: 0,
          paddingRight: 0,
          uid: "EjCDC8OJZC",
        },
      ],
    },
  ],
  style: {
    h1: {
      "font-family": "Ubuntu, sans-serif",
      "font-size": "22px",
      "font-weight": "bold",
    },
    a: { color: "#0000EE" },
    h2: {
      "font-family": "Ubuntu, Helvetica, Arial",
      "font-size": "17px",
      "font-weight": "bold",
    },
    h3: {
      "font-family": "Ubuntu, Helvetica, Arial",
      "font-size": "13px",
      "font-weight": "bold",
    },
    p: { "font-family": "Ubuntu, sans-serif", "font-size": "11px" },
    ul: { "font-size": "11px", "font-family": "Ubuntu, sans-serif" },
    li: { "font-size": "11px", "font-family": "Ubuntu, sans-serif" },
    ol: { "font-size": "11px", "font-family": "Ubuntu, sans-serif" },
    ".rounded>table": { "border-collapse": "separate" },
  },
  fonts: ["Ubuntu, sans-serif", "Ubuntu, Helvetica, Arial"],
  feedBlocksApplyToAll: {},
};

const template3 = {
  tagName: "mj-global-style",
  attributes: {
    "h1:color": "#000",
    "h1:font-family": "Helvetica, sans-serif",
    "h2:color": "#000",
    "h2:font-family": "Ubuntu, Helvetica, Arial, sans-serif",
    "h3:color": "#000",
    "h3:font-family": "Ubuntu, Helvetica, Arial, sans-serif",
    ":color": "#000",
    ":font-family": "Ubuntu, Helvetica, Arial, sans-serif",
    ":line-height": "1.5",
    "a:color": "#24bfbc",
    "button:background-color": "#e85034",
    containerWidth: 600,
    fonts: "Helvetica,sans-serif,Ubuntu,Arial",
    "mj-text": {
      "line-height": 1.5,
      "font-size": 15,
      "font-family": "Ubuntu, sans-serif",
    },
    "mj-button": { "font-size": "13px" },
  },
  children: [
    {
      tagName: "mj-body",
      attributes: { "background-color": "#FFFFFF", containerWidth: 600 },
      children: [
        {
          tagName: "mj-section",
          attributes: {
            "full-width": "600px",
            padding: "10px 10px",
            "mj-class": "section",
            "in-group": true,
          },
          children: [
            {
              tagName: "mj-column",
              attributes: {
                width: "70%",
                "vertical-align": "middle",
                "background-color": "#E85034",
                "border-radius": "10px",
                padding: "0px 5px 0px 5px",
                "css-class": "rounded",
              },
              children: [
                {
                  tagName: "mj-text",
                  uid: "ibae6wOpP",
                  customKey: null,
                  attributes: {
                    align: "left",
                    padding: "15px 15px 15px 15px",
                    "line-height": 1.5,
                    containerWidth: 420,
                  },
                  content:
                    "<p>This is your new text block with first paragraph.</p>",
                },
              ],
              uid: "HJQ8ytZzW",
            },
            {
              tagName: "mj-column",
              attributes: { width: "30%", "vertical-align": "middle" },
              children: [
                {
                  tagName: "mj-social",
                  uid: "_t-luQINW",
                  attributes: {
                    padding: "5px 5px 5px 5px",
                    "text-mode": "false",
                    "icon-size": "30px",
                    align: "right",
                    containerWidth: 180,
                    "icon-padding": "1px",
                  },
                  children: [
                    {
                      tagName: "mj-social-element",
                      attributes: {
                        src: "https://s3-eu-west-1.amazonaws.com/ecomail-assets/editor/social-icos/ikony-black/roundedblack/facebook.png",
                        name: "facebook-noshare",
                        alt: "Facebook",
                        href: "https://www.facebook.com/PROFILE",
                        "background-color": "transparent",
                        show: true,
                      },
                    },
                    {
                      tagName: "mj-social-element",
                      attributes: {
                        src: "https://s3-eu-west-1.amazonaws.com/ecomail-assets/editor/social-icos/ikony-black/roundedblack/x.png",
                        name: "x-noshare",
                        alt: "X",
                        href: "https://www.x.com/PROFILE",
                        "background-color": "transparent",
                        show: true,
                      },
                    },
                    {
                      tagName: "mj-social-element",
                      attributes: {
                        src: "https://s3-eu-west-1.amazonaws.com/ecomail-assets/editor/social-icos/ikony-black/roundedblack/linkedin.png",
                        name: "linkedin-noshare",
                        alt: "LinkedIn",
                        href: "https://www.linkedin.com/PROFILE",
                        "background-color": "transparent",
                        show: true,
                      },
                    },
                    {
                      tagName: "mj-social-element",
                      attributes: {
                        src: "https://s3-eu-west-1.amazonaws.com/ecomail-assets/editor/social-icos/ikony-black/roundedblack/instagram.png",
                        name: "instagram",
                        alt: "Instagram",
                        href: "https://www.instagram.com/PROFILE",
                        "background-color": "transparent",
                        show: true,
                      },
                    },
                  ],
                  style: "ikony-black/roundedblack",
                },
              ],
              uid: "uYQDAfdIz9",
            },
          ],
          layout: 1,
          backgroundColor: null,
          backgroundImage: null,
          paddingTop: 0,
          paddingBottom: 0,
          paddingLeft: 0,
          paddingRight: 0,
          uid: "Byggju-zb",
        },
        {
          tagName: "mj-section",
          attributes: {
            "full-width": false,
            padding: "10px 10px",
            "mj-class": "section",
          },
          children: [
            {
              tagName: "mj-column",
              attributes: { width: "100%", "vertical-align": "top" },
              children: [
                {
                  tagName: "mj-image",
                  uid: "CWyAe1Vit",
                  customKey: null,
                  attributes: {
                    alt: "",
                    containerWidth: 600,
                    href: "",
                    padding: "0px 0px 0px 0px",
                    src: "https://storage.googleapis.com/topol-io-plugin-97de3577-4897-4379-9699-a51756301fab/plugin-assets/17326/user/Enca_edited_only_jpg.jpg",
                    "fluid-on-mobile": "false",
                    "border-radius": "0px 0px 0px 0px",
                  },
                },
                {
                  tagName: "mj-button",
                  uid: "gKHNSFJuf",
                  customKey: null,
                  attributes: {
                    align: "center",
                    "background-color": "#000000",
                    color: "#ffffff",
                    "border-radius": "10px",
                    "font-size": "13px",
                    padding: "10px 0px 10px 0px",
                    "inner-padding": "10px 25px 10px 25px",
                    href: "https://google.com",
                    "font-family":
                      "Ubuntu, Helvetica, Arial, sans-serif, Helvetica, Arial, sans-serif",
                    containerWidth: 600,
                    "font-weight": "normal",
                    "font-style": "normal",
                    "text-transform": "none",
                    "text-decoration": "none",
                  },
                  content: "Click me!",
                },
              ],
              uid: "--FRAnCV-R",
            },
          ],
          layout: 1,
          backgroundColor: "",
          backgroundImage: "",
          paddingTop: 0,
          paddingBottom: 0,
          paddingLeft: 0,
          paddingRight: 0,
          uid: "UhrRhJgog",
        },
        {
          tagName: "mj-section",
          attributes: {
            "full-width": "600px",
            padding: "10px 10px",
            "mj-class": "section",
          },
          children: [
            {
              tagName: "mj-column",
              attributes: { width: "100%", "vertical-align": "top" },
              children: [
                {
                  tagName: "mj-text",
                  uid: "hzHpOgWUv",
                  customKey: null,
                  attributes: {
                    align: "left",
                    padding: "15px 15px 15px 15px",
                    "line-height": 1.5,
                    containerWidth: 600,
                  },
                  content:
                    "<p>This is your new text block with first paragraph.</p>",
                },
                {
                  tagName: "mj-button",
                  uid: "OKezUKnZ4",
                  customKey: null,
                  attributes: {
                    align: "center",
                    "background-color": "#e85034",
                    color: "#ffffff",
                    "border-radius": "8px",
                    "font-size": "13px",
                    padding: "10px 10px 10px 10px",
                    "inner-padding": "10px 20px 10px 20px",
                    href: "https://google.com",
                    "font-family":
                      "Ubuntu, Helvetica, Arial, sans-serif, Helvetica, Arial, sans-serif",
                    containerWidth: 600,
                    width: "100%",
                    "font-weight": "normal",
                    "font-style": "normal",
                    "text-transform": "none",
                    "text-decoration": "none",
                  },
                  content: "Click me!",
                },
              ],
              uid: "--FRAnCV-R",
            },
          ],
          layout: 1,
          backgroundColor: "",
          backgroundImage: "",
          paddingTop: 0,
          paddingBottom: 0,
          paddingLeft: 0,
          paddingRight: 0,
          uid: "wzaN4vqUQ",
        },
        {
          tagName: "mj-section",
          attributes: {
            "full-width": false,
            padding: "10px 10px",
            "mj-class": "section",
            "background-url":
              "https://storage.googleapis.com/topol-io-plugin-97de3577-4897-4379-9699-a51756301fab/plugin-assets/17326/user/testuju_separe.jpg",
            "background-size": "Cover",
            "background-repeat": "no-repeat",
            "css-class": "hide_section_on_mobile",
          },
          children: [
            {
              tagName: "mj-column",
              attributes: { width: "100%", "vertical-align": "top" },
              children: [
                {
                  tagName: "mj-divider",
                  uid: "74pW-aT8_",
                  attributes: {
                    "border-color": "#000000",
                    "border-style": "solid",
                    "border-width": "1px",
                    "padding-top": "10px",
                    "padding-right": "10px",
                    containerWidth: 600,
                    padding: "10px 10px",
                  },
                },
                {
                  tagName: "mj-spacer",
                  uid: "eAnpeTpgm",
                  attributes: {
                    height: "300px",
                    containerWidth: 600,
                    "css-class": "",
                  },
                },
                {
                  tagName: "mj-divider",
                  uid: "Xat5PBjpP",
                  attributes: {
                    "border-color": "#000000",
                    "border-style": "solid",
                    "border-width": "1px",
                    "padding-top": "10px",
                    "padding-right": "10px",
                    containerWidth: 600,
                    padding: "10px 10px",
                  },
                },
              ],
              uid: "--FRAnCV-R",
            },
          ],
          layout: 1,
          backgroundColor: "",
          backgroundImage: "",
          paddingTop: 0,
          paddingBottom: 0,
          paddingLeft: 0,
          paddingRight: 0,
          uid: "lzm8qI-TS",
        },
      ],
    },
  ],
  fonts: ["Ubuntu, sans-serif", "Ubuntu, Helvetica, Arial"],
  style: {
    h1: {
      "font-family": "Ubuntu, sans-serif",
      "font-size": "22px",
      "font-weight": "bold",
    },
    a: { color: "#0000EE" },
    h2: {
      "font-family": "Ubuntu, Helvetica, Arial",
      "font-size": "17px",
      "font-weight": "bold",
    },
    h3: {
      "font-family": "Ubuntu, Helvetica, Arial",
      "font-size": "13px",
      "font-weight": "bold",
    },
    p: { "font-family": "Ubuntu, sans-serif", "font-size": "11px" },
    ul: { "font-size": "11px", "font-family": "Ubuntu, sans-serif" },
    li: { "font-size": "11px", "font-family": "Ubuntu, sans-serif" },
    ol: { "font-size": "11px", "font-family": "Ubuntu, sans-serif" },
    ".rounded>table": { "border-collapse": "separate" },
  },
  feedBlocksApplyToAll: {},
  langs: [
    {
      key: "en",
      primary: true,
      translations: {
        ibae6wOpP: { content: "<p>Test for Englich mutation</p>" },
        CWyAe1Vit: {
          attributes: {
            src: "https://storage.googleapis.com/topol-io-plugin-97de3577-4897-4379-9699-a51756301fab/plugin-assets/17326/user/Enca_edited_only_jpg.jpg",
            alt: "",
            href: "",
          },
        },
        gKHNSFJuf: {
          content: "<div>So click to me!</div>",
          attributes: { href: "https://google.com" },
        },
        hzHpOgWUv: { content: "<p>Other test for english mutation</p>" },
        OKezUKnZ4: {
          content: "<div>Here click</div>",
          attributes: { href: "https://google.com" },
        },
      },
    },
    {
      key: "cs",
      primary: false,
      translations: {
        ibae6wOpP: { content: "<p>Toto je test pro českou mutaci</p>" },
        CWyAe1Vit: {
          attributes: {
            src: "https://storage.googleapis.com/topol-io-plugin-97de3577-4897-4379-9699-a51756301fab/plugin-assets/17326/user/Enca_edited_22cc0ade-67ac-4fc8-9230-9b8a912ba30f.jpg",
            title: "Pro česko",
            alt: "Pro česko",
          },
        },
        gKHNSFJuf: {
          content: "<div>Klik na mě!</div>",
          attributes: { href: "https://google.com/cs" },
        },
        hzHpOgWUv: { content: "<p>Další test pro česko</p>" },
        OKezUKnZ4: {
          content: "<div>Klikej tu!</div>",
          attributes: { href: "https://google.com/cs" },
        },
      },
    },
  ],
};

const autosaves = [
  {
    uid: "5f85804f746rer",
    key: "test4",
    time: "2025-06-19T10:25:31+00:00",
    created_by: {
      user_id: "user",
      profile_photo_url:
        "https://ui-avatars.com/api/?name=J+E&color=7F9CF5&background=EBF4FF",
      name: "Jana Englická",
    },
  },
  {
    uid: "5f85804f74675",
    key: "test1",
    time: "2024-10-14T10:25:31+00:00",
    created_by: {
      user_id: "user",
      profile_photo_url:
        "https://ui-avatars.com/api/?name=J+E&color=7F9CF5&background=EBF4FF",
      name: "Jana Englická",
    },
  },
  {
    uid: "5f85804f7RR5",
    key: "test2",
    time: "2024-10-14T07:25:31+00:00",
    created_by: {
      user_id: "user",
      profile_photo_url:
        "https://ui-avatars.com/api/?name=J+E&color=7F9CF5&background=EBF4FF",
      name: "Jana Englická",
    },
  },
  {
    uid: "5f85804f74tz75",
    key: "test3",
    time: "2023-10-14T10:25:31+00:00",
  },
];

export const getAllAutosaves = () => {
  return new Response(
    JSON.stringify({
      success: true,
      data: autosaves,
    }),
    {
      status: 200,
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
};

function getTemplate(autosaveId) {
  switch (autosaveId) {
    case "test1":
      return template1;
    case "test2":
      return template2;
    case "test4":
      return template3;
    default:
      return template1;
  }
}

export const getAutosave = ({ params }) => {
  const { autosaveId } = params;
  const returnTemplate = getTemplate(autosaveId);
  return new Response(
    JSON.stringify({
      success: true,
      data: {
        template: JSON.stringify(returnTemplate),
      },
    }),
    {
      status: 200,
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
};

export const addAutosave = async ({ request }) => {
  const body = await request.json();
  const { definition, key, templateId, uuid } = body;

  if (
    definition !== undefined &&
    key !== undefined &&
    templateId !== undefined &&
    uuid !== undefined
  ) {
    autosaves.push({
      uid: "5f85804f74676",
      key: "2.mjml",
      time: "2023-11-14T10:25:31+00:00",
    });
    return new Response("", {
      status: 200,
      headers: {
        "Content-Type": "application/json",
      },
    });
  }
};
